export const RouteEnum = {
	// BASE
	ERROR_403: "error.403",
	ERROR_404: "error.404",

	// AUTH
	LOCALE_CHOOSE: "localeChoose",
	LOGIN: "auth.login",
	LOGOUT: "auth.logout",
	PASSWORD_FORGOT: "auth.password.forgot",
	PASSWORD_RESET: "auth.password.reset",

	//APP
	ORDERS: "orders.index",
	USER_ORDERS: "user.orders.index",
	PRODUCTS: "products.list",
	USER_PRODUCTS: "user.products.list",
	PRODUCTS_PREVIEW: "products.preview",
	USER_PRODUCTS_PREVIEW: "user.products.preview",
	ORDERS_PREVIEW: "orders.preview",
	USER_ORDERS_PREVIEW: "user.orders.preview",
	ORDERS_STATUS_LOGS: "orders.statusLogs",
	USER_ORDERS_STATUS_LOGS: "user.orders.statusLogs",
	CART: "cart",
	USER_CART: "user.cart",
	CHECKOUT: "checkout",
	USER_CHECKOUT: "user.checkout",
	CHECKOUT_CONTRACTOR_ADDRESS_ADD: "checkout.contractorsAddresses.add",
	USER_CHECKOUT_CONTRACTOR_ADDRESS_ADD: "user.checkout.contractorsAddresses.add",

	MY_CONTRACTORS_ADDRESSES: "myContractorsAddresses.index",
	USER_MY_CONTRACTORS_ADDRESSES: "user.myContractorsAddresses.index",

	MY_CONTRACTORS_ADDRESSES_ADD: "myContractorsAddresses.add",
	USER_MY_CONTRACTORS_ADDRESSES_ADD: "user.myContractorsAddresses.add",

	MY_CONTRACTORS_ADDRESSES_EDIT: "myContractorsAddresses.edit",
	USER_MY_CONTRACTORS_ADDRESSES_EDIT: "user.myContractorsAddresses.edit",
};
